import React, { useLayoutEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import CalculatorPage from './CalculatorPage';
import QuizPage from './QuizPage';

function App() {
  const appRef = useRef(null);

  useLayoutEffect(() => {
    const appElement = appRef.current;
    if (!appElement) return;

   
    const targetOrigin = '*'; 

    const sendHeight = () => {
      const height = appElement.scrollHeight;
      window.parent.postMessage({ 
        type: 'luna-app-resize', 
        height: height,
        path: window.location.pathname 
      }, targetOrigin);
    };

    sendHeight();

    const resizeObserver = new ResizeObserver(sendHeight);
    resizeObserver.observe(appElement);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <Router>
      <div className="App" ref={appRef}>
        <Routes>
          <Route path="/" element={<CalculatorPage />} />
          <Route path="/furniture_fit_calculator" element={<CalculatorPage />} />
          <Route path="/personality_test" element={<QuizPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;